import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=5b3190a0&"
import script from "./BaseSelect.vue?vue&type=script&lang=js&"
export * from "./BaseSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=5b3190a0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3190a0')) {
      api.createRecord('5b3190a0', component.options)
    } else {
      api.reload('5b3190a0', component.options)
    }
    module.hot.accept("./BaseSelect.vue?vue&type=template&id=5b3190a0&", function () {
      api.rerender('5b3190a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/core/BaseSelect.vue"
export default component.exports